import React, { Component } from 'react';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';
import { TemplateSFObjectStore } from '../../../../store/models/template-object.model';
import { observer } from 'mobx-react';

class GridEditSelected extends Component<any, any>{

    constructor(props: any) {
        super(props);
        this.state = {
            isEditable: false
        };
    }

    render() {
        const ruleElement = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        const gridObject = ruleElement.hasOwnProperty('gridObject') ? { ...ruleElement.gridObject } : {};
        const headerActios = gridObject.hasOwnProperty('headerActions') ? { ...gridObject.headerActions } : {};
        return (
            <div className={`slds-dropdown-trigger slds-dropdown-trigger_click slds-button_last ${this.state.isEditable && 'slds-is-open'}`}>
                <button className="slds-button slds-button_icon slds-button_icon-border-filled" aria-haspopup="true" title="Show More" onClick={this.toggleEditDropDown}>
                    <i className="cq-icon-down"></i>
                </button>
                <div className="slds-dropdown slds-dropdown_right slds-dropdown_actions">
                    <ul className="slds-dropdown__list" role="menu">
                        {
                            this.props.headerActionType.length && this.props.headerActionType.map((recordType: any, index: any) => {
                                if (recordType.hasOwnProperty('recordTypeId')) {
                                    return <li className="slds-dropdown__item slds-grid slds-grid_vertical-align-center slds-grid_align-spread" role="presentation" onClick={() => this.setSelectedAction(recordType, 'standardHeaderAction')}>
                                        <a>
                                            {
                                                recordType.name === 'New' ? <span className="slds-truncate">New</span> : <span className="slds-truncate">New {recordType.name}</span>
                                            }

                                        </a>
                                        {
                                            headerActios.hasOwnProperty(recordType.developerName) && headerActios[recordType.developerName].isRuleApplied ? <i className="cq-icon-eye"></i> : null
                                        }
                                    </li>
                                } 
                                else {
                                    return <li className="slds-dropdown__item slds-grid slds-grid_vertical-align-center slds-grid_align-spread" role="presentation" onClick={() => this.setSelectedAction(recordType.name, 'addedCustomHeaderAction')}>
                                        <a>
                                            <span className="slds-truncate">{recordType.name}</span>
                                        </a>
                                        {
                                            headerActios.hasOwnProperty(recordType.name) && headerActios[recordType.name].isRuleApplied && <i className="cq-icon-eye"></i>
                                        }
                                    </li>
                                }

                            })
                        }
                        <li className="slds-dropdown__item slds-p-around_x-small" role="presentation">
                            <a className="slds-button slds-button_outline-brand" onClick={() => this.setSelectedAction('customAction', 'customHeaderAction')}>
                                Define Custom Action
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        )
    }

    /**
     * @private
     * @memberof GridTabEditSelected
     */
    private setSelectedAction = (name: any, actionType: string) => {
        const selectedAction = {
            name,
            actionType
        }
        CQMasterDataStore.GridObject.updateGridField('selectedHeaderAction', selectedAction);
        CQMasterDataStore.GridObject.updateGridField('selectedAction', actionType);
        this.toggleEditDropDown();
    }

    /**
     * @private
     * @memberof GridTabEditSelected
     */
    private toggleEditDropDown = () => {
        this.setState({
            isEditable: !this.state.isEditable
        })
    }
}

export const GridTabEditSelected = observer(GridEditSelected)